import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import WhatsAppButton from "../../components/feature/WhatsAppButton";
import HeroSection from "./components/HeroSection";
import BenefitsSection from "./components/BenefitsSection";
import AboutDoctorSection from "./components/AboutDoctorSection";
import ServicesPreview from "./components/ServicesPreview";
import EducationSection from "./components/EducationSection";
import CTASection from "./components/CTASection";
import TestimonialsSection from "./components/TestimonialsSection";
import LocationSection from "./components/LocationSection";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

  const schemaClinic = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Clínica de Colposcopia Dr. Erick Tejada",
    "description": "Especialistas en colposcopia, detección de VPH, Papanicolaou y ginecología preventiva en Ciudad de Panamá.",
    "url": siteUrl,
    "telephone": "+507-6613-2697",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "El Dorado, al lado del Do It Center",
      "addressLocality": "Ciudad de Panamá",
      "addressCountry": "PA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 8.9936,
      "longitude": -79.5197
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "medicalSpecialty": "Gynecology",
    "paymentAccepted": "Cash",
    "priceRange": "$$",
    "image": "https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/b33c731a0a8a80a76070c43759aaf839.png",
    "sameAs": ["https://www.instagram.com/drericktejada/"]
  };

  const schemaWebSite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Dr. Erick Tejada - Ginecólogo Colposcopista Panamá",
    "url": siteUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/?s={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <title>Colposcopia en Panamá | Dr. Erick Tejada - Ginecólogo Especialista en VPH</title>
      <meta name="description" content="Clínica de Colposcopia Dr. Erick Tejada en Ciudad de Panamá. Especialista en detección de VPH, Papanicolaou y ginecología preventiva. Detección temprana de cáncer cervicouterino. Agenda tu cita: +507 6613-2697." />
      <meta name="keywords" content="colposcopia en Panamá, ginecólogo en Panamá, detección de VPH Panamá, Papanicolaou Panamá, Dr. Erick Tejada" />
      <link rel="canonical" href={siteUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Colposcopia en Panamá | Dr. Erick Tejada - Ginecólogo Especialista en VPH" />
      <meta property="og:description" content="Especialista en colposcopia, detección de VPH y Papanicolaou en Ciudad de Panamá. Prevención y detección temprana de cáncer cervicouterino." />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:image" content="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/b33c731a0a8a80a76070c43759aaf839.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Colposcopia en Panamá | Dr. Erick Tejada" />
      <meta name="twitter:description" content="Especialista en colposcopia, detección de VPH y Papanicolaou en Ciudad de Panamá." />
      <script type="application/ld+json">{JSON.stringify(schemaClinic)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaWebSite)}</script>
      <main>
        <Navbar />
        <HeroSection />
        <BenefitsSection />
        <AboutDoctorSection />
        <ServicesPreview />
        <EducationSection />
        <TestimonialsSection />
        <LocationSection />
        <CTASection />
        <Footer />
        <WhatsAppButton />
      </main>
    </>
  );
}
